export const LINE_HEIGHT = {
  LG: 1.5,
  MD: 1.25,
  SM: 1,
} as const;
